//import { text } from '@fortawesome/fontawesome-svg-core';
import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

// Vuex is our global state management system, which uses the global "store"
// We inject our store in the app so we can call this.$store.state.loggedin to see global state of login
// To change state, we use the commit method on a mutation, like this: this.$store.commit('startLogin');
// To call an action, we use the dispatch method, like this: this.$store.dispatch('logout');
export const store = new Vuex.Store({
    state: {
        // Login state
        loggingin: false,
        loggedin: false,
        user: null, // From UsersController: user.email, user.firstName, user.lastName, user.Token

        userlist: [],

        // This is set while we read/write gamestate to the DB
        savingState: false,
        loadingState: false,


        gamestate: {
            email: "",
            progressWellBeing: 0,
            progressEngagement: 0,
            progressExpression: 0,
            progressMembership: 0,
            area: 0,
            situation: 0,
            currentClue: 0,
            completed: [false, false, false, false, false, false, false, false, false, false, false, false],
            clues: [
                false, false, false, false, false, false,  // 6 objects (clues) per 8 levels
                false, false, false, false, false, false,
                false, false, false, false, false, false,
                false, false, false, false, false, false,
                false, false, false, false, false, false,
                false, false, false, false, false, false,
                false, false, false, false, false, false,
                false, false, false, false, false, false,
                false, false, false, false, false, false,
                false, false, false, false, false, false,
                false, false, false, false, false, false,
                false, false, false, false, false, false
            ],
            currentSelection: -1,
            watchedVideo: false,
            watchedSituationVideo: [false, false, false, false, false, false, false, false, false, false, false, false],
            returnpage: "",
            muted: false,
            newVersion: false,
            registeredAudioId: "",
            blocNote: [
                // {
                //     currentlyEditing = false,
                //     situation: 0,
                //     id: 0, // 0=video, 1=indice1, 2=indice2, 3=indice3, 4=indice4, 5=indice5
                //     text: "user text",
                //     date: new Date()
                // },
                // ...
            ]
        },

        // dbInfo is a table in the DB - see DbGameState, GameStateController and UpdateStateModel in backend
        dbInfo: {
            email: "",
            gameInfo: "",
        },


    },
    actions: {
        logout({ commit }) {
            commit("logout");
            commit("resetGameState");
        }
    },
    mutations: {

        setRegisteredAudioId(state, value) {
            state.gamestate.registeredAudioId = value;
        },
        setNewVersion(state, value) {
            state.gamestate.newVersion = value;
        },
        clearUserList(state) {
            state.userlist = [];
        },
        addUserToList(state, user) {
            state.userlist.push(user);
        },
        deleteUser(state, email) {
            for (var i = 0; i < state.userlist.length; i++) {
                var thisUser = state.userlist[i];
                if (thisUser.email == email) {
                    console.log("Removing user: " + i + " with email: " + email + " and last name: " + thisUser.lastName);
                    state.userlist.splice(i, 1);
                    return;
                }
            }
        },
        // Used to test the admin functionality without backend
        createFakeUserList(state) {
            state.userlist = [];
            var testUser1 = {
                email: "email1@hotmail.com",
                firstName: "Jim",
                lastName: "Smith",
                Token: "AAA"
            }
            var testUser2 = {
                email: "email2@hotmail.com",
                firstName: "Joey",
                lastName: "Jo-Jo",
                Token: "BBB"
            }
            var testUser3 = {
                email: "email3@hotmail.com",
                firstName: "Annie",
                lastName: "Jamison",
                Token: "CCC"
            }
            var testUser4 = {
                email: "email4@hotmail.com",
                firstName: "Krista",
                lastName: "Bray",
                Token: "DDD"
            }
            state.userlist.push(testUser1);
            state.userlist.push(testUser2);
            state.userlist.push(testUser3);
            state.userlist.push(testUser4);
        },
        updateDbInfo(state) {
            state.dbInfo.email = this.state.gamestate.email;
            state.dbInfo.gameInfo = JSON.stringify(this.state.gamestate);
        },
        startLogin(state) {
            state.loggedin = false;
            state.loggingin = true;
            //console.log("startLogin!!!!!");
        },
        cancelLogin(state) {
            state.loggedin = false;
            state.loggingin = false;
            //console.log("cancelLogin!!!!!");
        },
        completeLogin(state, user) {
            state.loggedin = true;
            state.loggingin = false;
            state.user = user;
            state.gamestate.email = state.user.email;
            //console.log("logged in!!!!!");
        },
        startLoadingGameState(state) {
            state.loadingState = true;
        },
        completeLoadingGameState(state) {
            state.loadingState = false;
        },
        startSavingGameState(state) {
            state.savingState = true;
        },
        completeSavingGameState(state) {
            state.savingState = false;
        },
        logout(state) {
            state.loggedin = false;
            state.loggingin = false;
            state.user = null;
            //console.log("logout!!!!!");
        },
        resetGameState(state) {
            state.gamestate.email = "";
            state.dbInfo.email = "";
            state.gamestate.progressWellBeing = 0;
            state.gamestate.progressEngagement = 0;
            state.gamestate.progressExpression = 0;
            state.gamestate.progressMembership = 0;
            state.gamestate.area = 0;
            state.gamestate.situation = 0;
            state.gamestate.currentClue = 0;
            for (var i = 0; i < state.gamestate.completed.length; i++) {
                state.gamestate.completed[i] = false;
            }
            for (var j = 0; j < state.gamestate.clues.length; j++) {
                state.gamestate.clues[j] = false;
            }
            state.gamestate.currentSelection = -1;
            state.gamestate.watchedVideo = false;
            for (var k = 0; k < state.gamestate.watchedSituationVideo.length; k++) {
                state.gamestate.watchedSituationVideo[k] = false;
            }
            state.gamestate.returnpage = "";
            state.gamestate.muted = false;
            //state.gamestate.newVersion = false;  // Let's never reset this unles it is user driven, othewrwise confusing
            state.gamestate.registeredAudioId = "";
            state.gamestate.blocNote = [];
        },

        setEmail(state, value) {
            state.gamestate.email = value;
        },
        setReturnpage(state, value) {
            state.gamestate.returnpage = value;
            console.log("Return page is " + state.gamestate.returnpage);
        },
        setProgressWellBeing(state, value) {
            state.gamestate.progressWellBeing = value;
        },
        setProgressEngagement(state, value) {
            state.gamestate.progressEngagement = value;
        },
        setProgressExpression(state, value) {
            state.gamestate.progressExpression = value;
        },
        setProgressMembership(state, value) {
            state.gamestate.progressMembership = value;
        },
        setArea(state, value) {
            state.gamestate.area = value;
        },
        setSituation(state, value) {
            state.gamestate.situation = value;
        },
        clearSituationData(state) {
            state.gamestate.currentClue = 0;
            for (var j = 0; j < state.gamestate.clues.length; j++) {
                state.gamestate.clues[j] = false;
            }
            state.gamestate.currentSelection = -1;
        },
        setCurrentClue(state, value) {
            state.gamestate.currentClue = value;
        },
        setMuted(state, value) {
            state.gamestate.muted = value;
        },
        setCurrentSelection(state, value) {
            state.gamestate.currentSelection = value;
        },
        setSituationComplete(state, value) {

            //state.gamestate.completed[value] = true;
            //console.log("Setting situation COMPLETE on " + value);
            // TBD this is to make it reactive:  https://vuejs.org/v2/guide/reactivity.html
            Vue.set(state.gamestate.completed, value, true);

        },
        setSituationReset(state, value) {
            //state.gamestate.completed[value] = false;
            // This makes it reactive!
            //console.log("Setting situation reset on " + value);
            Vue.set(state.gamestate.completed, value, false);
        },
        setClueFound(state, value) {
            //state.gamestate.clues[value] = true;
            // This makes it reactive!
            Vue.set(state.gamestate.clues, value, true);

        },
        setClueReset(state, value) {
            //state.gamestate.clues[value] = false;
            // This makes it reactive!
            Vue.set(state.gamestate.clues, value, false);
        },
        setWatchedVideo(state, value) {
            state.gamestate.watchedVideo = value;
        },
        setWatchedSituationVideo(state, value) {
            //state.gamestate.watchedSituationVideo[value] = true;
            // This makes it reactive!
            Vue.set(state.gamestate.watchedSituationVideo, value, true);
        },
        setResetSituationVideo(state, value) {
            //state.gamestate.watchedSituationVideo[value] = false;
            // This makes it reactive!
            Vue.set(state.gamestate.watchedSituationVideo, value, false);
        },
        setSaveGame(state) {
            localStorage.setItem('gamestate', JSON.stringify(state.gamestate));
        },
        incrementProgressWellBeing(state, delta) {
            state.gamestate.progressWellBeing += delta;
        },
        incrementProgressEngagement(state, delta) {
            state.gamestate.progressEngagement += delta;
        },
        incrementProgressExpression(state, delta) {
            state.gamestate.progressExpression += delta;
        },
        incrementProgressMembership(state, delta) {
            state.gamestate.progressMembership += delta;
        },
        addToBlocNote(state, value) {
            // value = {
            //     situation: 0,
            //     id: 0, // 0=video, 1=indice1, 2=indice2, 3=indice3, 4=indice4, 5=indice5
            //     text: "user text",
            //     date: new Date()
            // }
            state.gamestate.blocNote.push(value)
        },
        editElemBlocNote(state, value) {
            // value = {
            //     situation: 0,
            //     id: 0, // 0=video, 1=indice1, 2=indice2, 3=indice3, 4=indice4, 5=indice5
            //     text: "user text",
            //     date: new Date()
            // }
            Vue.set(state.gamestate.blocNote.find(x => x.situation == value.situation && x.id == value.id), "text", value.text)
            Vue.set(state.gamestate.blocNote.find(x => x.situation == value.situation && x.id == value.id), "date", value.date)
        },
        removeElemBlocNote(state, value) {
            // value = {
            //     situation: 0,
            //     id: 0, // 0=video, 1=indice1, 2=indice2, 3=indice3, 4=indice4, 5=indice5
            // }
            let i = state.gamestate.blocNote.map(x => x.situation == value.situation && x.id == value.id).indexOf(true);
            state.gamestate.blocNote.splice(i, 1);
        }

    }
});